module.exports = __webpack_public_path__ + "img/xxzx.cf03e97d.png";